import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McdUtilLineList = ({ mcdUtil }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcdUtil) return;

    rowsReq.partition = mcdUtil.partition;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcdUtilId', mcdUtil.id));
  }, [mcdUtil?.partition, mcdUtil?.id]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Utlization Lines come from system only
  }

  return (
    <EntityList entity="MCD_UTIL_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />
  )
}
